import { gql } from '@apollo/client';

export const GET_MEMBER_PROJECTS = gql`
  query MyQuery($memberId: ID!, $isProfileView: Boolean) {
    getProjectAllocatedHours(
      memberId: $memberId
      isProfileView: $isProfileView
    ) {
      hoursPerWeek
      project {
        colorCode
        projectName
        projectStatus
        tentativeEndDate
        tentativeStartDate
      }
      roleStartDate
      roleEndDate
      memberStatus
    }
  }
`;

export const GET_MEMBER_SKILLS = gql`
  query MyQuery($id: ID!) {
    getMemberSkills(memberId: $id) {
      id
      proficiencyLevel
      skill {
        id
        image
        name
      }
      validatorId
      status
    }
  }
`;

export const GET_SKILL_VALIDATOR = gql`
  query GetSkillValidator($id: ID!) {
    getMember(id: $id) {
      displayName
      id
    }
  }
`;

export const GET_SKILLS = gql`
  query MyQuery {
    getSkills {
      name
      id
    }
  }
`;

export const GET_VALIDATORS = gql`
  query GetValidators($displayName: String!, $roles: [String]) {
    getMembers(filter: { displayName: $displayName, roles: $roles }) {
      data {
        id
        displayName
      }
    }
  }
`;

export const CREATE_MEMBER_SKILL = gql`
  mutation MyMutation(
    $memberId: ID!
    $skillId: ID!
    $proficiencyLevel: ProficiencyLevels!
    $validatorId: ID!
  ) {
    createMemberSkill(
      input: {
        memberId: $memberId
        skillId: $skillId
        proficiencyLevel: $proficiencyLevel
        validatorId: $validatorId
        status: PENDING
      }
    )
  }
`;

export const EDIT_MEMBER_SKILL = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $memberSkillId: ID!
    $memberId: ID!
    $skillId: ID!
    $proficiencyLevel: ProficiencyLevels!
    $validatorId: ID!
    $generateApprovalRequest: Boolean
    $generateNotification: Boolean
  ) {
    editMemberSkill(
      input: {
        actionUserId: $actionUserId
        memberSkillId: $memberSkillId
        memberId: $memberId
        skillId: $skillId
        proficiencyLevel: $proficiencyLevel
        validatorId: $validatorId
        generateApprovalRequest: $generateApprovalRequest
        generateNotification: $generateNotification
      }
    )
  }
`;

export const DELETE_MEMBER_SKILL = gql`
  mutation DeleteMemberSkill($id: ID!) {
    deleteMemberSkill(id: $id)
  }
`;

export const GET_SYSTEM_ROLES = gql`
  query GetSystemRoles($roles: [String]) {
    getSystemRoles(roles: $roles) {
      userRole
      id
    }
  }
`;
